const emailBrRegExp =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

export default abstract class Formatter {
  static textoCapitular(str: string): string {
    if (!str) return ''
    let result = str.toLowerCase()
    result = result.charAt(0).toUpperCase() + result.slice(1)
    return result
  }

  static caracteresNaoNumericosNemLetras(): RegExp {
    const reg = /[^\w]/gi
    return RegExp(reg)
  }

  static somenteNumeros(): RegExp {
    const reg = /[^0-9]/g
    return RegExp(reg)
  }
}

const phoneRegExp = /\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}-[0-9]{4}$/
const phoneMask = (value: string): string => {
  value = value.replace(Formatter.somenteNumeros(), '')
  if (value.length === 11) {
    value = value.replace(/\D/g, '')
    value = value.replace(/^(\d\d)(\d)/g, '($1) $2')
    value = value.replace(/(\d{5})(\d)/, '$1-$2')
  } else {
    value = value.replace(/\D/g, '')
    value = value.replace(/^(\d\d)(\d)/g, '($1) $2')
    value = value.replace(/(\d{4})(\d)/, '$1-$2')
  }
  return value
}

export const normalizeCnpj = (value: string): string =>
  value
    ? value
        .replace(/[^0-9a-z]/gi, '')
        .toUpperCase()
        .slice(0, 14)
    : ''

const cnpjMask = (value: string): string => {
  if (!value) return ''

  const normalizedValue = normalizeCnpj(value)
  const parts = [
    normalizedValue.slice(0, 2),
    normalizedValue.slice(2, 5),
    normalizedValue.slice(5, 8),
    normalizedValue.slice(8, 12),
    normalizedValue.slice(12, 14),
  ].filter(Boolean)

  if (parts.length === 1) return parts[0]
  if (parts.length === 2) return `${parts[0]}.${parts[1]}`
  if (parts.length === 3) return `${parts[0]}.${parts[1]}.${parts[2]}`
  if (parts.length === 4)
    return `${parts[0]}.${parts[1]}.${parts[2]}/${parts[3]}`

  return `${parts[0]}.${parts[1]}.${parts[2]}/${parts[3]}-${parts[4]}`
}
const cpfMask = (value: string): string => {
  if (!value) return ''
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
}

export const cpfCnpjMask = (valor: string) => {
  if (!valor) return

  const novoValor = normalizeCnpj(valor)

  if (novoValor.length === 11) {
    return cpfMask(novoValor)
  }
  if (novoValor.length === 14) {
    return cnpjMask(novoValor)
  }

  return novoValor
}
const cepMask = (value: string): string => {
  return value.replace(/^([\d]{5})-*([\d]{3})/, '$1-$2')
}
const numberToCurrency = (value: number): string =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(value)

const convertDateToStringBrazilianPattern = (date: Date): string => {
  if (!date) return ''
  const p = date.toString().split(/\D/g)
  return [p[2], p[1], p[0]].join('/')
}

const formatBankSlip = (codigoBarras: string): string => {
  if (
    codigoBarras &&
    codigoBarras.trim() !== '' &&
    !isNaN(Number(codigoBarras)) &&
    codigoBarras.length <= 48
  ) {
    const ultimaPosicaoRegex = {
      44: 11,
      43: 10,
      47: 14,
      48: 15,
    }
    const regex = `^(\\d{5})(\\d{5})(\\d{5})(\\d{6})(\\d{5})(\\d{6})(\\d{1})(\\d{${
      ultimaPosicaoRegex[codigoBarras.length]
    }})$`

    return codigoBarras.replace(new RegExp(regex), '$1.$2 $3.$4 $5.$6 $7 $8')
  }
  return codigoBarras
}

const removeCaracteresEspeciais = (value: string): string | null => {
  return value ? value.replace(/[^A-Za-z0-9]/g, '') : null
}

export {
  emailBrRegExp,
  phoneRegExp,
  phoneMask,
  cnpjMask,
  cepMask,
  cpfMask,
  numberToCurrency,
  convertDateToStringBrazilianPattern,
  formatBankSlip,
  removeCaracteresEspeciais,
}
